<template>
  <div class="companies">
    <section class="section-header">
      <h1>
        <Link to="/admin/users">Admin</Link>
        {{ $t('meta.companies') }}
      </h1>
      <div class="meta">
        <Link to="/admin/companies/new" class="button button-green button-round button-small">{{
          $t('companies.addCompany')
        }}</Link>
      </div>
    </section>

    <div class="body-content cf">
      <div class="entries-wrap">
        <admin-nav></admin-nav>
        <div class="body">
          <LoadingSpinner v-if="loading" full />
          <div v-else>
            <SearchField
              :label="$t('meta.searchForLabel', { entity: $t('companies.company') })"
              :name="'company-search-input'"
              :placeholder="$t('admin.company.searchPlaceholder')"
              v-model="searchPhrase"
              @input="searchHandler"
            />
            <div v-for="company in companies" :key="company.uuid" class="admin-table">
              <Link
                :to="`/admin/companies/${company.uuid}`"
                :class="{ 'marked-as-deleted': company.deleted_at != null }"
              >
                <span style="width: 90%">{{ company.name }}</span>
                <span class="material-icons" style="width: 10%; text-align: right">edit</span>
              </Link>
            </div>
            <div v-if="pagination && pagination.totalObjects > 0" class="pagination">
              <pagination
                :records="pagination.totalObjects"
                v-model="pagination.page"
                :per-page="pagination.perPage"
                @paginate="getCompanies"
                :options="{ chunk: 5, texts: { count: $t('pagination.text') } }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'

import SearchField from '@/components/Form/Search/SearchField'
import LoadingSpinner from '@/components/LoadingSpinner'
import AdminNav from '@/components/admin_nav'
import stringUtils from '@/components/mixins/stringUtils'

import adminsApi from '@/api/admin'

export default {
  components: {
    AdminNav,
    LoadingSpinner,
    Pagination,
    SearchField,
  },
  mixins: [stringUtils],
  data() {
    return {
      companies: [],
      loading: true,
      pagination: {
        page: 1,
        totalObjects: 0,
        perPage: 0,
      },
      searchPhrase: '',
    }
  },
  methods: {
    searchHandler() {
      this.loading = true
      this.getCompanies()
    },
    async getCompanies(page) {
      const currentPage = page || this.pagination.page
      this.loading = true
      const params = { page: currentPage, per_page: 25 }
      if (this.searchPhrase.length > 0) {
        params['search_phrase'] = this.searchPhrase
      }
      const result = await adminsApi.companies.getCompanies(params)
      if (!result) {
        this.loading = false
        return
      }
      this.companies = result.companies.sort((a, b) => this.compareLocaleString(a.name, b.name))
      this.pagination.page = currentPage
      this.pagination.totalObjects = result.pagination?.total_objects
      this.pagination.perPage = result.pagination?.per_page
      this.loading = false
    },
  },
  mounted() {
    this.getCompanies()
  },
}
</script>
